var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableRowSkeleton',{attrs:{"columns":_vm.columns,"size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }